export enum ProtectionLevel {
    NONE = 0,
    AUTHENTICATED = 1 << 0, // 1
    ACCOUNT_SELECTED = 1 << 1, // 2
    PRODUCTION_SELECTED = 1 << 2, // 4
}
